import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ModalService } from '../modal.service';
import { RightSideDrawerService } from 'src/app/shared/right-side-drawer/right-side-drawer.service';


@Component({
    selector: 'email-tips-modal',
    templateUrl: './email-tips-modal.component.html',
    styleUrls: ['./email-tips-modal.component.scss']
})

export class EmailTipsModal implements OnInit, AfterViewInit {
    constructor(@Inject(DOCUMENT) private _document: Document, 
                private renderer: Renderer2, 
                private _modalService: ModalService, 
                private _rightSideDrawerService: RightSideDrawerService
                ) {
    }

    ngOnInit(): void { }

    ngAfterViewInit(): void {
        let modalBody = this._document.getElementById('modal-content-body') as HTMLElement;
        if (modalBody) {
            this.renderer.setStyle(modalBody, 'height', '83%');
            this.renderer.setStyle(modalBody, 'width', '45%');
        }
    }

    closeExpenseDataGuide(): void {
        this._rightSideDrawerService.setEmailTipsModal(false);
    }
}